import { useMemo } from 'react'
import { Text } from '@app/components/core/typography/Text'
import { TextLink } from '@app/components/core/link/TextLink'
import Column from '@app/components/layout/Column'
import { tokenizeContent, extractEventSlugs } from '@app/util/parseContentLinks'
import { EventLinkCard } from './EventLinkCard'

export type PostContentProps = {
  content: string
}

export const PostContent = ({ content }: PostContentProps) => {
  const tokens = useMemo(() => tokenizeContent(content), [content])
  const slugs = useMemo(() => extractEventSlugs(content), [content])

  return (
    <Column gap="0.5rem" alignItems="stretch">
      <Text.Medium style={{ lineHeight: '1.75rem' }}>
        {tokens.map((token, i) =>
          token.type === 'url' ? (
            <TextLink key={i} to={token.href ?? token.value}>
              {token.value}
            </TextLink>
          ) : (
            token.value
          ),
        )}
      </Text.Medium>

      {slugs.map((slug) => (
        <EventLinkCard key={slug} slug={slug} />
      ))}
    </Column>
  )
}
